import { useToken, useUTLSettingsContext } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { useCallback, useMemo } from "react";

export const useDelayNotificationAccess = () => {
	const {
		state: { settings },
	} = useUTLSettingsContext();
	const { getFirstName } = useToken();
	const userName = getFirstName();

	const EAF_DELAY_NOTIFICATION_ENABLED = get(
		settings,
		"FF_EAF_DELAY_NOTIFICATION_ENABLED",
		0,
	);

	const EAF_DELAY_NOTIFICATION_TIME_IN_MINUTES = get(
		settings,
		"EAF_DELAY_NOTIFICATION_TIME_IN_MINUTES",
		60,
	);

	const userCleaned = userName.trim();
	const hasAccess =
		!!Number(EAF_DELAY_NOTIFICATION_ENABLED) &&
		(userCleaned === "EAF1" ||
			userCleaned === "EAF2" ||
			userCleaned === "Admin");

	const delayJustificationDismissed = useCallback(() => {
		const localStorageDismissTimestamp: string | null =
			localStorage.getItem("dismiss_timestamp");

		if (!localStorageDismissTimestamp) return false;

		const now: number = Date.now();
		const dismissTimestamp: Date = new Date(localStorageDismissTimestamp);
		const datetimeDiff: number = now - dismissTimestamp.getTime();

		const isTimeToShowPopup: boolean =
			datetimeDiff < EAF_DELAY_NOTIFICATION_TIME_IN_MINUTES * 60 * 1000;

		return isTimeToShowPopup;
	}, [EAF_DELAY_NOTIFICATION_TIME_IN_MINUTES]);

	const dismissDelayJustification = useCallback(() => {
		localStorage.setItem("dismiss_timestamp", new Date().toISOString());
	}, []);

	return {
		hasAccess,
		dismissDelayJustification,
		EAF_DELAY_NOTIFICATION_TIME_IN_MINUTES,
		delayJustificationDismissed,
	};
};
